export default __webpack_public_path__ + "static/media/06_photo.8b8d6079.jpeg";